import { configureStore } from '@reduxjs/toolkit';

import comboSummaryApp from '../reducers/comboSummary';

// `common` is the host-page state object seeded through `preloadedState`. `devTools` is dev-only;
// dev checks stay on.
export const createComboSummaryStore = (common) =>
  configureStore({
    reducer: comboSummaryApp,
    preloadedState: { common },
    devTools: process.env.NODE_ENV !== 'production',
  });
